<template>
  <path
    d="M12 7.77018L18.39 18.0002H5.61002L12 7.77018ZM11.15 5.36018L2.95002 18.4702C2.54002 19.1402 3.02002 20.0002 3.80002 20.0002H20.2C20.99 20.0002 21.46 19.1402 21.05 18.4702L12.85 5.36018C12.46 4.73018 11.54 4.73018 11.15 5.36018Z"
  />
</template>
